import { IPublicClientApplication } from "@azure/msal-browser";
import { getToken } from "Components/Functions";
import { api } from "./apiConfig"

export const ServiceMessagesAPI = {
    get: async function (employerId?: number) {
        const apiCall = await api();
        const response = await apiCall.request({
            url: `General/GetServiceMessages?employer_id=${employerId ?? 0}`,
            method: "GET"
        })
        return response.data
    }
}
export const ParamAPI = {
    get: async function (parameter: string) {
        const apiCall = await api();
        const response = await apiCall.request({
            url: `General/GetParameter?param=${parameter}`,
            method: "GET"
        })
        return response.data
    }
}
export const OptionsAPI = {
    get: async function (entity:string) {
        const apiCall = await api();
        const response = await apiCall.request({
            url: `General/GetOptions?entity=${entity}`,
            method: "GET",
        })
        return response.data
    }
}
export const TermsConditionsAPI = {
    confirm: async function (instance: IPublicClientApplication, bookingId: number) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: `Booking/ConfirmTermsConditions?booking_id=${bookingId}`,
            method: "POST",
            headers: { Authorization: header }
        })
        return response.data
    }
}
export const FooterAPI = {
    get: async function () {
        const apiCall = await api();
        const response = await apiCall.request({
            url: `General/GetFooterInformation`,
            method: "GET",
        })
        return response.data
    }
}